// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuDesktop_root__KxJZ6","itemWrapper":"MenuDesktop_itemWrapper__1sbv8"};